export function print_error(e) {
    $('#error_msg').html(e);
}

export function clear_error(e) {
    print_error('');
}


export function alert_von_bis(v, b, v_label, b_label, the_focus) {
// Shows a message if 'von'-Time is set after 'bis'-Time
    var res=moment_datetime_range_validation(v, b, b_label + " muss NACH " + v_label + " liegen", '#submit_button');
    if (res==false) {
        $(the_focus).val('');
        $(the_focus).focus();
    }
}
	
	
		
export function reset_dauer(dauer) {
// sets the hidden form element for a 'dauer' to null and writes some empty text into the inner of a 'span'
	if (dauer) {
		$(dauer).val('');
		$('#value_' + dauer.substring(1)).html('--');
	}
}


		
export function calculate_dauer(time_from, time_to, dauer, the_focus) {
// this function assumes a correct time-format!
// 1. Sets the hidden variable 'dauer' to the amount of minutes as the difference time_to-time_from
// 2. prints the Text as innerHTML in the DOM-element with the id 'value_'+dauer

    $('.error').hide();

        var d = moment_get_duration(time_from, time_to)

        if ($(time_from).val() && $(time_to).val() && d>0) {
            d = d/1000/60;
            $(dauer).val(d/60); //  d/60 for hours!!
            //console.log('calculate_dauer',dauer,d);
            $('#value_' + dauer.substring(1)).text(d + 'min');
        } else {
            //reset_dauer(dauer);
            //alert_von_bis(time_from, time_to, 'von', 'bis', the_focus);
        }

}



export function calculate_vorort_dauer() {
// Dauer Vor ort ist Gesamt Dauer - UB im Rahmen einer Fahrt
    var dauer=$('#record_dauer').val();
    var ub_fahrt_dauer=$('#record_ub_fahrt_dauer').val();
    if (dauer) {
		if (ub_fahrt_dauer=="") {
            ub_fahrt_dauer = 0;
		}
        var vor_ort_dauer=Number(dauer) - Number(ub_fahrt_dauer);
        //console.log('calculate_vorort_dauer','ub_fahrt_dauer',ub_fahrt_dauer, 'dauer',dauer, 'vor_ort_dauer',vor_ort_dauer)
		$('#record_ub_vorort_dauer_ist').val(vor_ort_dauer);
		$('#value_record_ub_vorort_dauer_ist').html(Math.round(vor_ort_dauer*60)+'min');
	}
}



export function check_pause_between(time_to, time_from, pause_type, the_focus) {
    var res=moment_datetime_range_validation(time_to, time_from, 'Bis muss NACH Von liegen. ', '#submit_button');
    var t=moment_time(time_to);
    var f=moment_time(time_from);
    var d = moment_get_duration(time_to, time_from)/1000/60;

    if (!res) {
		switch(the_focus) {
			case '#msbrecord_anfahrt_bis', '#record_von':
				alert_von_bis(time_to, time_from, 'Anfahrtsende', 'Betreuungsbeginn', the_focus);
				break;
			case '#record_bis', '#msbrecord_rueckfahrt_von':
                alert_von_bis(time_to, time_from, 'Betreuungsende', 'Rueckfahrtsbeginn', the_focus);
				break;
		}
		
	} else if (t.isValid() && f.isValid() && d!=0) {
		$('#region_'+pause_type.substring(1)).attr('class','visible');
		$('#value_'+pause_type.substring(1)).html(d+'min');
	
	} else {
		$('#region_'+pause_type.substring(1)).attr('class', 'hidden');
		$('#value_'+pause_type.substring(1)).html('');
	}
}




export function check_betreuungszeiten(the_focus) {
	// checks overlapping time-windows for von<=ub_fahrt_von<ub_fahrt_bis<=bis
	var von = moment_datetime('#record_von');
	var bis = moment_datetime('#record_bis');
	var ub_fahrt_von = moment_datetime('#record_ub_fahrt_von');
	var ub_fahrt_bis = moment_datetime('#record_ub_fahrt_bis');
    //console.log('Zeiten', 'von',von,'ub_fahrt_von',ub_fahrt_von,'ub_fahrt_bis',ub_fahrt_bis,'bis',bis);
	//console.log('check_betreuungszeiten','moment(von).isSameOrBefore(ub_fahrt_von)',moment(von).isSameOrBefore(ub_fahrt_von),'moment(ub_fahrt_von).isBefore(ub_fahrt_bis)',moment(ub_fahrt_von).isBefore(ub_fahrt_bis),'moment(ub_fahrt_bis).isSameOrBefore(bis)',moment(ub_fahrt_bis).isSameOrBefore(bis));
    $('.error').hide();
    if (von.isValid() && bis.isValid() && ub_fahrt_von.isValid() && ub_fahrt_bis.isValid()) {
		if (!(moment(von).isSameOrBefore(ub_fahrt_von, 'minute') && moment(ub_fahrt_von).isBefore(ub_fahrt_bis, 'minute') && moment(ub_fahrt_bis).isSameOrBefore(bis, 'minute'))) {
			print_error('Betreuungszeiten dürfen sich nicht überlappen');
			//reset_values(the_focus);
		} 
	}
}



export function check_for_open_time_windows(von, bis) {
// returns 1 if neither both nor none of the 'von' - 'bis' values are present (XOR)
	if ( !((!$(von).val() && !$(bis).val()) || ($(von).val() && $(bis).val())) )
		return 1
	else
		return 0
}


export function check_for_completeness() {
	// checks if all time-pairs which are used, are complete

	var count_open_time_windows = 0;
	
	if (is_visible('#msb_time_form_anfahrt'))
		count_open_time_windows += check_for_open_time_windows('#msbrecord_anfahrt_von', '#msbrecord_anfahrt_bis');
	
	if (is_visible('#msb_time_form_kb')) {
        if ( (!$('#record_von').val() || !$('#record_bis').val()) && (!$('#anfahrt_von').val() && !$('#anfahrt_bis').val() ) && (!$('#rueckfahrt_von').val() && !$('#rueckfahrt_bis').val() )  ) {
            count_open_time_windows += 1
        }
        count_open_time_windows += check_for_open_time_windows('#record_von', '#record_bis');
        count_open_time_windows += check_for_open_time_windows('#record_ub_fahrt_von', '#record_ub_fahrt_bis');
    }
	
	if (is_visible('#msb_time_form_rueckfahrt'))
		count_open_time_windows += check_for_open_time_windows('#msbrecord_rueckfahrt_von', '#msbrecord_rueckfahrt_bis');
		
	return count_open_time_windows;
}





export function format_time(the_field, the_datetime) {
	// returns as string in format hh:mm (first and second component of  the_datetime -> rails returns 'YYYY-MM-DD hh:mm:ss'
	if ($(the_datetime).val()) {
        $(the_field).val(moment_time(the_datetime));
	}
}




	export function set_to_all_day() {
		if ($('#task_all_day').val('true')) {
			$('#record_all_day').val(1);
			$('#form_row_ende').show();
			$('#label_row_anfang').html('Von');
            $('#form_row_von_bis').hide();
            $('#form_row_client').hide();
            $('#form_row_employee').hide();
            $('#form_row_contact_status').hide();
            $('#form_row_fahrzeug').hide();
            $('#form_row_msb_anmerkung').hide();
            $('#form_region_all_day').hide();
			
			reset_values('#msbrecord_anfahrt_von');
			reset_values('#msbrecord_anfahrt_bis');
			reset_values('#msbrecord_rueckfahrt_von');
			reset_values('#msbrecord_rueckfahrt_bis');
			reset_values('#record_ub_fahrt_von');
			reset_values('#record_ub_fahrt_bis');
			
		} else {
			$('#record_all_day').val(0);
            $('#form_row_ende').hide();
			$('#label_row_anfang').html('Datum');
            $('#form_region_all_day').hide();
            $('#form_row_von_bis').show();
            $('#form_row_client').show();
            $('#form_row_employee').show();
            $('#form_row_contact_status').show();
            $('#form_row_fahrzeug').show();
            $('#form_row_msb_anmerkung').show();
			
		}
	}




    export function show_anfahrt() {
        $('#msb_time_form_anfahrt').show();
        $('#region_pause_anfahrt');
    }

    export function hide_anfahrt(depth) {
        $('#msb_time_form_anfahrt').show();
        $('#region_pause_anfahrt').hide();
    }

    export function show_rueckfahrt() {
        $('#region_pause_rueckfahrt').hide();
        $('#msb_time_form_rueckfahrt').show();
    }

    export function hide_rueckfahrt(depth) {
        $('#region_pause_rueckfahrt').hide();
        $('#msb_time_form_rueckfahrt').hide();

    }

    export function show_kb(depth, title) {
        //V2 if (depth=='complete')
        //V2 InnerHTML('form_section_title_betreuung', title);
        $('#msb_time_form_kb').show();
    }

    export function hide_kb(depth, title) {
        $('#msb_time_form_kb').hide();
    }
		
		
		
		

export function set_msb_form_element_visibility(e, v) {

    if (v=='visible') {
        $('#msb_time_form_'+e).show();
    } else {
        $('#msb_time_form_'+e).hide();
    }

}



export function reset_values(the_field) {
	if (the_field) {
  	if ($(the_field)) 
  		$(the_field).val('');
  	
  	switch (the_field) {
  		case '#msbrecord_anfahrt_von':
  		case '#msbrecord_anfahrt_bis':
  			reset_dauer('#msbrecord_anfahrt_dauer_ist');
  			check_pause_between('#msbrecord_anfahrt_bis', '#record_von', '#pause_anfahrt', the_field);
  			break;
  		case '#record_von':
  		case '#record_bis':
  			reset_dauer('#record_dauer');
  			reset_dauer('#record_ub_vorort_dauer_ist');
  			check_pause_between('#msbrecord_anfahrt_bis', '#record_von', '#pause_anfahrt', the_field);
  			check_pause_between('#record_bis', '#msbrecord_rueckfahrt_von', '#pause_rueckfahrt', the_field);
  			break;
  		case '#record_ub_fahrt_von':
  		case '#record_ub_fahrt_bis':
  			reset_dauer('#record_ub_fahrt_dauer');
  			reset_dauer('#record_ub_vorort_dauer_ist');
  			break;
  		case '#msbrecord_rueckfahrt_von':
  		case '#msbrecord_rueckfahrt_bis':
  			reset_dauer('#msbrecord_rueckfahrt_dauer_ist');
  			check_pause_between('#record_bis', '#msbrecord_rueckfahrt_von', '#pause_rueckfahrt', the_field);
  			break;
  	}
  }
	
}

    export function reset_all_values() {
        reset_values("#msbrecord_anfahrt_von");
        reset_values("#msbrecord_anfahrt_bis");
        reset_values("#msbrecord_rueckfahrt_von");
        reset_values("#msbrecord_rueckfahrt_bis");
        reset_values("#record_von");
        reset_values("#record_bis");
        reset_values("#record_ub_fahrt_von");
        reset_values("#record_ub_fahrt_bis");
        reset_values("#msbrecord_anfahrt_startadresse");
        reset_values("#msbrecord_anfahrt_zieladresse");
        reset_values("#msbrecord_anfahrt_km_ist");
        reset_values("#msbrecord_rueckfahrt_startadresse");
        reset_values("#msbrecord_rueckfahrt_zieladresse");
        reset_values("#msbrecord_rueckfahrt_km_ist");
        reset_values("#record_ub_fahrt_startadresse");
        reset_values("#record_ub_fahrt_zieladresse");
        reset_values("#record_ub_fahrt_km");
    }


    export function reset_hidden_values() {
        if (!is_visible('#msb_time_form_anfahrt')) {
            reset_values("#msbrecord_anfahrt_von");
            reset_values("#msbrecord_anfahrt_bis");
            reset_values("#msbrecord_anfahrt_startadresse");
            reset_values("#msbrecord_anfahrt_zieladresse");
            reset_values("#msbrecord_anfahrt_km_ist");
        }

        if (!is_visible('#msb_time_form_kb')) {
            reset_values("#record_von");
            reset_values("#record_bis");
            reset_values("#record_ub_fahrt_von");
            reset_values("#record_ub_fahrt_bis");
            reset_values("#record_ub_fahrt_startadresse");
            reset_values("#record_ub_fahrt_zieladresse");
            reset_values("#record_ub_fahrt_km");
        }


        if (!is_visible('#msb_time_form_rueckfahrt')) {
            reset_values("#msbrecord_rueckfahrt_von");
            reset_values("#msbrecord_rueckfahrt_bis");
            reset_values("#msbrecord_rueckfahrt_startadresse");
            reset_values("#msbrecord_rueckfahrt_zieladresse");
            reset_values("#msbrecord_rueckfahrt_km_ist");
        }
    }



export function prepare_msb_form_values() {
	// in edit mode: 
	// 1. reformats the time-fields from hh:mm:ss to hh:mm
	// 2. calculates dauer

    $('#msb_time_form_anfahrt').hide();
    $('#msb_time_form_rueckfahrt').hide();
    var f='YYYY-MM-DD HH:mm:ss Z';
    var von=moment($('#record_von').val(), f);
    var bis=moment($('#record_bis').val(), f);
    var fahrt_von=moment($('#record_fahrt_von').val(), f);
    var fahrt_bis=moment($('#record_fahrt_bis').val(), f);
    var ub_fahrt_von=moment($('#record_ub_fahrt_von').val(), f);
    var ub_fahrt_bis=moment($('#record_ub_fahrt_bis').val(), f);

    if ($('#msb_rueckfahrt_id').val() == $('#record_task_id').val()) {
        $('#msb_time_form_rueckfahrt').show('fast');
        // Rueckfahrt...
        $('#rueckfahrt_von').val(fahrt_von.format('HH:mm'));
        $('#rueckfahrt_bis').val(fahrt_bis.format('HH:mm'));
        compose_datetime('#msbrecord_rueckfahrt_von', '#von_date', '#rueckfahrt_von');
        time_changed('#msbrecord_rueckfahrt_von');
        compose_datetime('#msbrecord_rueckfahrt_bis', '#von_date', '#rueckfahrt_bis');
        time_changed('#msbrecord_rueckfahrt_bis');
        $('#msbrecord_rueckfahrt_dauer_ist').val($('#record_fahrt_dauer_ist').val());
        $('#msbrecord_rueckfahrt_startadresse').val($('#record_fahrt_startadresse').val());
        $('#msbrecord_rueckfahrt_zieladresse').val($('#record_fahrt_zieladresse').val());
        $('#msbrecord_rueckfahrt_km_ist').val($('#record_fahrt_km_ist').val());

        $('#record_fahrt_von').val('');
        $('#record_fahrt_bis').val('');
        $('#record_fahrt_dauer_ist').val('');
        $('#record_fahrt_startadresse').val('');
        $('#record_fahrt_zieladresse').val('');
        $('#record_fahrt_km_ist').val('');
    }
    else if ($('#record_fahrt_von').val()) {
        //Anfahrt
        $('#msb_time_form_anfahrt').show('fast');
        $('#anfahrt_von').val(fahrt_von.format('HH:mm'));
        $('#anfahrt_bis').val(fahrt_bis.format('HH:mm'));
        compose_datetime('#msbrecord_anfahrt_von', '#von_date', '#anfahrt_von');
        time_changed('#msbrecord_anfahrt_von');
        compose_datetime('#msbrecord_anfahrt_bis', '#von_date', '#anfahrt_bis');
        time_changed('#msbrecord_anfahrt_bis');
        $('#msbrecord_anfahrt_dauer_ist').val($('#record_fahrt_dauer_ist').val());
        $('#msbrecord_anfahrt_startadresse').val($('#record_fahrt_startadresse').val());
        $('#msbrecord_anfahrt_zieladresse').val($('#record_fahrt_zieladresse').val());
        $('#msbrecord_anfahrt_km_ist').val($('#record_fahrt_km_ist').val());

        $('#record_fahrt_von').val('');
        $('#record_fahrt_bis').val('');
        $('#record_fahrt_dauer_ist').val('');
        $('#record_fahrt_startadresse').val('');
        $('#record_fahrt_zieladresse').val('');
        $('#record_fahrt_km_ist').val('');

    }
    if ($('#record_ub_fahrt_von').val()) {
        $('#ub_fahrt_von').val(ub_fahrt_von.format('HH:mm'));
        $('#ub_fahrt_bis').val(ub_fahrt_bis.format('HH:mm'));
        compose_datetime('#record_ub_fahrt_von', '#von_date', '#ub_fahrt_von');
        time_changed('#record_ub_fahrt_von');
        compose_datetime('#record_ub_fahrt_bis', '#von_date', '#ub_fahrt_bis');
        time_changed('#record_ub_fahrt_bis');
    }
    compose_datetime('#record_von', '#von_date', '#von_time');
    time_changed('#record_von');
    compose_datetime('#record_bis', '#von_date', '#bis_time');
    time_changed('#record_bis');

 /*   if ($('#record_von').val()) {
        $('#von_time').val(von.format('HH:mm'));
        $('#bis_time').val(bis.format('HH:mm'));
        compose_datetime('#record_von', '#von_date', '#von_time');
        time_changed('#record_von');
        compose_datetime('#record_bis', '#von_date', '#bis_time');
        time_changed('#record_bis');
    } */
    if ($('#record_fahrt_von').val()==$('#record_von').val() && $('#record_fahrt_von').val()==$('#record_bis').val()) {
        //reset_values("#record_von");
        //reset_values("#record_bis");
    }

	
	format_comma('#msbrecord_anfahrt_km_ist', 'fromdb');
	format_comma('#record_ub_fahrt_km', 'fromdb');
	format_comma('#msbrecord_rueckfahrt_km_ist', 'fromdb');
	
}



    export function set_msb_time_form() {

        if ($('#record_ub_fahrt_von').val() || $('#record_ub_fahrt_bis').val())
            var kb_depth='complete'
        else
            var kb_depth='normal'

        if ($('#task_type_code').val()=="KB" && $('#task_code').val()!="msb_rueckfahrt" && $('#task_code').val()!="fahrt_ib") {
            show_anfahrt();
            show_kb(kb_depth, 'Betreuung');
            show_rueckfahrt();

        } else if ($('#task_code').val()=="msb_rueckfahrt") {
            hide_anfahrt('complete');
            hide_kb('complete', 'Nur Fahrtzeit');
            show_rueckfahrt();

        } else if ($('#task_code').val()=="fahrt_ib") {
            show_anfahrt();
            hide_kb('complete', 'Nur Fahrtzeit');
            hide_rueckfahrt('complete');


        } else {
            hide_anfahrt('complete');
            show_kb(kb_depth, 'Zeit')
            hide_rueckfahrt('complete');
        }
    }



    export function paint_form() {

        $('#region_pause_anfahrt').attr('class', 'pause_hidden');
        $('#region_pause_rueckfahrt').attr('class', 'pause_hidden');

        ElementShow("weekday_von");
        ElementShow("weekday_bis");
        set_weekday('record', 'von');
        set_weekday('record', 'bis');
        set_msb_time_form();
        set_to_all_day();
        SetPageToIdle();
    }



    export function setup_form_for_add_mode() {

        set_msb_form_element_visibility('anfahrt', 'visible');
        set_msb_form_element_visibility('kb', 'hidden');
        set_msb_form_element_visibility('rueckfahrt', 'visible');

        if ($('#last_bis').val() && !$('#msbrecord_anfahrt_von').val() && is_visible('#msb_time_form_anfahrt')) {
            // voriges last-bis
            $('#msbrecord_anfahrt_von').val($('#last_bis').val());
        }
        set_clients_select_list_to_multiple();
        paint_form();
    }



    export function setup_form_for_edit_mode() {

        if ($('#set_client_select_multiple').val()=='true')
            select_multiple_clients_in_list();

        prepare_msb_form_values();
        paint_form();
    }




    export function km_changed(the_field) {
        //format_comma(the_field, 'todb');
        // do nothing after typing - change comma in 'final check'
    }


    export function time_changed(the_field) {
        clear_error();
        if (moment_datetime_validation(the_field, 'Falsche Zeitangabe', '#submit_button')) {

            switch (the_field) {
                case '#msbrecord_anfahrt_von':
                    compose_datetime('#msbrecord_anfahrt_von', '#von_date', '#anfahrt_von');
                case '#msbrecord_anfahrt_bis':
                    compose_datetime('#msbrecord_anfahrt_bis', '#von_date', '#anfahrt_bis');
                    calculate_dauer('#msbrecord_anfahrt_von', '#msbrecord_anfahrt_bis', '#msbrecord_anfahrt_dauer_ist', '#anfahrt_bis');
                    if ($('#msbrecord_anfahrt_bis').val() && !$('#record_von').val() && $('#form_mode').val()!='edit') {
                        $('#record_von').val($('#msbrecord_anfahrt_bis').val());
                        var t= moment_datetime('#record_von');
                        $('#von_time').val(t.format('HH:mm'));
                        calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time');
                    }
                    calc_datetime_form();
                    check_pause_between('#msbrecord_anfahrt_bis', '#record_von', '#pause_anfahrt', the_field);

                    break;

                case '#von_time':
                    compose_datetime('#record_von', '#von_date', '#von_time', {'all_day': $('#record_all_day').val()});
                    calc_datetime_form();
                    calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time');
                    check_betreuungszeiten('#record_von');
                    calculate_vorort_dauer();
                    check_pause_between('#msbrecord_anfahrt_bis', '#record_von', '#pause_anfahrt', '#record_von');
                    break;


                case '#record_von':
                    compose_datetime('#record_von', '#von_date', '#von_time', {'all_day': $('#record_all_day').val()});
                    calc_datetime_form();
                    calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time');
                    check_betreuungszeiten(the_field);
                    calculate_vorort_dauer();
                    check_pause_between('#msbrecord_anfahrt_bis', '#record_von', '#pause_anfahrt', the_field);
                    //get_contact_type();

                    // update other datetime_felds, if date was updated
                    if ($('#msbrecord_anfahrt_von').val())
                        time_changed('#msbrecord_anfahrt_von');
                    if ($('#msbrecord_anfahrt_bis').val())
                        time_changed('#msbrecord_anfahrt_bis');
                    if ($('#record_ub_fahrt_von').val())
                        time_changed('#record_ub_fahrt_von');
                    if ($('#record_ub_fahrt_bis').val())
                        time_changed('#record_ub_fahrt_bis');
                    if ($('#msbrecord_rueckfahrt_von').val())
                        time_changed('#msbrecord_rueckfahrt_von');
                    if ($('#msbrecord_rueckfahrt_bis').val())
                        time_changed('#msbrecord_rueckfahrt_bis');
                    break;

                case '#record_bis':
                    compose_datetime('#record_bis', '#bis_date', '#bis_time', {'all_day': $('#record_all_day').val(), 'day_offset': 1});
                    calc_datetime_form();
                    calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time');
                    calculate_vorort_dauer();
                    check_betreuungszeiten(the_field);
                    check_pause_between('#record_bis', '#msbrecord_rueckfahrt_von', '#pause_rueckfahrt', the_field);
                    break;

                case '#record_ub_fahrt_von':
                    compose_datetime('#record_ub_fahrt_von', '#von_date', '#ub_fahrt_von');
                case '#record_ub_fahrt_bis':
                    compose_datetime('#record_ub_fahrt_bis', '#von_date', '#ub_fahrt_bis');
                    calc_datetime_form();
                    calculate_dauer('#record_ub_fahrt_von', '#record_ub_fahrt_bis', '#record_ub_fahrt_dauer', '#ub_fahrt_bis');
                    calculate_vorort_dauer();
                    check_betreuungszeiten(the_field);

                    break;

                case '#msbrecord_rueckfahrt_von':
                    compose_datetime('#msbrecord_rueckfahrt_von', '#von_date', '#rueckfahrt_von');
                case '#msbrecord_rueckfahrt_bis':
                    compose_datetime('#msbrecord_rueckfahrt_bis', '#von_date', '#rueckfahrt_bis');
                    calc_datetime_form();
                    calculate_dauer('#msbrecord_rueckfahrt_von', '#msbrecord_rueckfahrt_bis', '#msbrecord_rueckfahrt_dauer_ist', '#rueckfahrt_bis');
                    check_pause_between('#record_bis', '#msbrecord_rueckfahrt_von', '#pause_rueckfahrt', the_field);
                    break;
            }


        } else if ($(the_field).val()) {
            print_error("Falsches Zeitformat! Bitte schreiben Sie die Zeitangabe als 'hh:mm'");
            reset_values(the_field);
            $(the_field).focus();
        } else {
            reset_values(the_field);
        }

    }


